var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCardBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141775",
    transform: "translate(599.5 492.625)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h27v27H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1535",
    transform: "translate(-599.5 -492.625)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48345",
    d: "M615.328 503.793h6.517v1.862h-6.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48346",
    d: "M615.328 499.141h10.241v1.862h-10.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48347",
    d: "M615.328 494.486h10.241v1.862h-10.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48348",
    d: "M607.879 519.624h-3.724a1.868 1.868 0 0 1-1.862-1.862v-6.517a1.868 1.868 0 0 1-1.862-1.862v-5.59a2.743 2.743 0 0 1 2.793-2.79h5.586a2.743 2.743 0 0 1 2.794 2.79v5.59a1.868 1.868 0 0 1-1.866 1.862v6.517a1.868 1.868 0 0 1-1.859 1.862Zm-4.655-16.759a.88.88 0 0 0-.931.931v5.587h1.862v8.379h3.724v-8.379h1.859v-5.59a.88.88 0 0 0-.931-.931Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48349",
    d: "M606.017 500.072a3.724 3.724 0 1 1 3.721-3.724 3.724 3.724 0 0 1-3.721 3.724Zm0-5.586a1.862 1.862 0 1 0 1.862 1.862 1.862 1.862 0 0 0-1.862-1.862Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCardBlue);
export default __webpack_public_path__ + "static/media/Profile_Card_Blue.92175730304e34a00a36c6b16336e892.svg";
export { ForwardRef as ReactComponent };